import useContent from './useContent';
import { defineStore, acceptHMRUpdate } from 'pinia';
import useQuizzes from './useQuizzes';
import { ref } from 'vue';

const useBadges = defineStore('badges', () => {
  const content = useContent().compiled;
  const { statuses } = useQuizzes();

  // TODO - this should be computed property of the badge properties for this page
  const getPageBadge = (pageId: string) => {
    if (!pageId) return false;
    const defaultBadge = Object.assign({}, content.badges);

    const badge = content?.badges?.pages?.find(p => p.page === pageId);
    if (!badge) return false;

    // overwrite default props with badge specific props
    const pageBadge = Object.assign(defaultBadge, badge);
    delete pageBadge.pages;

    // If no for-quiz force value to match page Id
    if (!pageBadge['for-quiz']) pageBadge['for-quiz'] = pageId;
    if (pageBadge) {
      return pageBadge;
    } else {
      return false;
    }
  };

  const getBadgeImage = badge => {
    if (!badge['img-default'] && !badge['img-success']) return;
    let badgeObject = {
      src: badge['img-default']
    };
    if (
      statuses[badge['for-quiz']]?.passed &&
      statuses[badge['for-quiz']]?.completed &&
      badge['img-success']
    ) {
      badgeObject.src = badge['img-success'];
    } else if (
      statuses[badge['for-quiz']]?.failed &&
      statuses[badge['for-quiz']]?.completed &&
      badge['img-failed']
    ) {
      badgeObject.src = badge['img-failed'];
    }

    return badgeObject;
  };

  // the badges collected count should be able to count down from a value
  const badgeCount = ref(0);

  const incrementBadgeCount = () => {
    badgeCount.value++;
  };

  const decrementBadgeCount = () => {
    badgeCount.value--;
  };

  return {
    getPageBadge,
    getBadgeImage,
    incrementBadgeCount,
    decrementBadgeCount
  };
});

export default useBadges;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBadges, import.meta.hot));
}
